import {
    REPORTS_HARVEST_INSPECTIONS_LOAD_REQUESTED,
    REPORTS_HARVEST_INSPECTIONS_LOAD_SUCCEEDED,
    REPORTS_HARVEST_INSPECTIONS_LOAD_FAILED,
    REPORTS_HARVEST_INSPECTIONS_POLLING_REQUESTED,
    REPORTS_HARVEST_INSPECTIONS_POLLING_SUCCEEDED,
    REPORTS_HARVEST_INSPECTIONS_POLLING_FAILED,
    REPORTS_HARVEST_INSPECTIONS_POLLING_CANCELED,
    REPORTS_HARVEST_INSPECTIONS_EXPORT_REQUESTED,
    REPORTS_HARVEST_INSPECTIONS_EXPORT_SUCCEEDED,
    REPORTS_HARVEST_INSPECTIONS_EXPORT_FAILED,
    REPORTS_HARVEST_INSPECTIONS_SET,
    REPORTS_HARVEST_INSPECTIONS_MERGE,
    REPORTS_HARVEST_INSPECTION_SET
} from './constants';

export function requestloadReportsHarvestInspections() {
    return {
        type: REPORTS_HARVEST_INSPECTIONS_LOAD_REQUESTED
    };
}

export function succeededLoadReportsHarvestInspections(
    response: Record<string, any>
) {
    return {
        type: REPORTS_HARVEST_INSPECTIONS_LOAD_SUCCEEDED,
        payload: response
    };
}

export function failedLoadReportsHarvestInspections(error: Error) {
    return {
        type: REPORTS_HARVEST_INSPECTIONS_LOAD_FAILED,
        payload: error,
        error: true
    };
}

export function requestPollingReportsHarvestInspections() {
    return {
        type: REPORTS_HARVEST_INSPECTIONS_POLLING_REQUESTED
    };
}

export function succeededPollingReportsHarvestInspections(
    response: Record<string, any>
) {
    return {
        type: REPORTS_HARVEST_INSPECTIONS_POLLING_SUCCEEDED,
        payload: response
    };
}

export function failedPollingReportsHarvestInspections(error: Error) {
    return {
        type: REPORTS_HARVEST_INSPECTIONS_POLLING_FAILED,
        payload: error,
        error: true
    };
}

export function canceledPollingReportsHarvestInspections() {
    return {
        type: REPORTS_HARVEST_INSPECTIONS_POLLING_CANCELED
    };
}

export function requestExportReportsHarvestInspections() {
    return {
        type: REPORTS_HARVEST_INSPECTIONS_EXPORT_REQUESTED
    };
}

export function succeededExportReportsHarvestInspections(
    response: Record<string, any>
) {
    return {
        type: REPORTS_HARVEST_INSPECTIONS_EXPORT_SUCCEEDED,
        payload: response
    };
}

export function failedExportReportsHarvestInspections(error: Error) {
    return {
        type: REPORTS_HARVEST_INSPECTIONS_EXPORT_FAILED,
        payload: error,
        error: true
    };
}

export function setReportsHarvestInspections(data: Record<string, any>[]) {
    return {
        type: REPORTS_HARVEST_INSPECTIONS_SET,
        payload: data,
        meta: {
            keyBy: 'eventId'
        }
    };
}

export function mergeReportsHarvestInspections(data: Record<string, any>[]) {
    return {
        type: REPORTS_HARVEST_INSPECTIONS_MERGE,
        payload: data
    };
}

export function setReportsHarvestInspection(data: Record<string, any>) {
    return {
        type: REPORTS_HARVEST_INSPECTION_SET,
        payload: data
    };
}
